import { render, staticRenderFns } from "./LetterSelector.vue?vue&type=template&id=0d983e8b&scoped=true"
import script from "./LetterSelector.vue?vue&type=script&lang=js"
export * from "./LetterSelector.vue?vue&type=script&lang=js"
import style0 from "./LetterSelector.vue?vue&type=style&index=0&id=0d983e8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d983e8b",
  null
  
)

export default component.exports